import OrganisationIcon from 'icons/OrganisationIcon';
import { memo } from 'react';

function NoContent({
  title = 'No team assigned',
  subTitle = 'Contact your Organization Admin to assign you to a team.',
  icon = <OrganisationIcon className="h-8 w-8" />,
  description = "Once you're on a team, you'll be able to manage your team's payroll and more!",
}: {
  title?: string;
  subTitle?: string;
  description?: string;
  icon?: React.ReactNode;
}) {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-[18px]">
      <div className="rounded-md border border-neutral-200 bg-neutral-50 p-3">{icon}</div>
      <h1 className="text-2xl font-medium text-neutral-800">{title}</h1>
      <div className="flex flex-col items-center rounded-lg bg-neutral-50 p-4">
        <p className="text-base font-medium text-neutral-800">{subTitle}</p>
        <p className="text-sm font-normal text-neutral-500">{description}</p>
      </div>
    </div>
  );
}

export default memo(NoContent);
